const STORAGE_KEY = 'gumb.trialNextStepHint';

const storage = (): Storage | null => {
  try {
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage;
  } catch {
    return null;
  }
};

export const readTrialNextStepHint = (): boolean =>
  storage()?.getItem(STORAGE_KEY) === '1';

export const persistTrialNextStepHint = (): void => {
  storage()?.setItem(STORAGE_KEY, '1');
};

export const clearTrialNextStepHint = (): void => {
  storage()?.removeItem(STORAGE_KEY);
};
